// extracted by mini-css-extract-plugin
export default {"root":"Textarea_root__yBx2U","invalid":"Textarea_invalid__g0iEO","disabled":"Textarea_disabled__mZOeY","error":"Textarea_error__g9dVZ"};